// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {ImageSrc, Href} from 'docs/markdoc/attribute-types';

export const HeroSection: MarkdocTagRegistration = {
  tag: 'hero-section',
  component: 'HeroSection',
  attributes: {
    title: {
      type: String,
      required: true,
      description: 'Title of hero section',
      localizable: true,
    },
    linkLabel: {
      type: String,
      required: true,
      localizable: true,
      description:
        'Display text for the link that is shown below the description',
    },
    linkHref: {
      type: Href,
      required: true,
      description: 'Href for the link that is shown below the description',
    },
    imageSrc: {
      type: ImageSrc,
      required: true,
      description: 'Path to the image file that is shown',
    },
    productBadge: {
      type: String,
      required: false,
      description:
        'Stripe product name (uses DocsIcon) to show the product icon as a badge in the top of the hero',
    },
    productBadges: {
      type: Array,
      required: false,
      description:
        'An array of Stripe product names (uses DocsIcon) to show the product icon as a badge in the top of the hero separated by a +',
    },
  },
};
